export function handleAddRow(columns, fieldProps, setTableData) {
  const newRow = {};
  columns.forEach((col) => {
    const format = fieldProps[col]?.format;
    if (format === "date" || format === "date-time") {
      newRow[col] = null;
    } else {
      newRow[col] = "";
    }
  });
  setTableData((prev) => [...prev, newRow]);
}

export function getQuestionByModule(followUp, moduleName) {
  for (const section of followUp?.sections ?? []) {
    for (const q of Object.values(section.questions ?? {})) {
      if (q.module === moduleName) {
        return q;
      }
    }
  }
  return null;
}

export function resetFieldsOnChange({ form, data, fieldsToWatch, resetMap }) {
  const updatedForm = { ...form };

  for (const field of fieldsToWatch) {
    if (data?.[field] !== form?.[field]) {
      for (const resetField of resetMap[field] || []) {
        updatedForm[resetField] = "";
      }
    }
  }

  return updatedForm;
}

export function getColumnSpan({
  isSingleFieldSchema,
  isOnlyOneField,
  shouldUseFullWidth,
  fieldIndex,
}) {
  if (isSingleFieldSchema || isOnlyOneField || shouldUseFullWidth) {
    return "md:col-span-12";
  }

  return fieldIndex % 2 === 0 ? "md:col-span-5" : "md:col-span-7";
}
